export default __webpack_public_path__ + "static/media/4c9d80f0ef19dd10c5f2e460bf98e9df1581605690884.6bc33cf6.webp";